import {
  FETCH_VARIANTS_MATRIX,
  FETCH_VARIANTS_MATRIX_FULFILLED,
  FETCH_VARIANTS_MATRIX_REJECTED,
} from 'b2b-apps/shop/product/redux/productVariantsMatrix/actionTypes';
import {
  FetchProductVariantsMatrixAction,
  FetchProductVariantsMatrixFulfilledAction,
  FetchProductVariantsMatrixRejectedAction,
  ProductVariantsMatrixType,
} from 'b2b-apps/shop/product/redux/productVariantsMatrix/types';

const fetchProductVariantsMatrix = (
  sku: string,
): FetchProductVariantsMatrixAction => ({
  type: FETCH_VARIANTS_MATRIX,
  payload: {
    sku,
  },
});

const fetchProductVariantsMatrixFulfilled = (
  sku: string,
  data: ProductVariantsMatrixType,
): FetchProductVariantsMatrixFulfilledAction => ({
  type: FETCH_VARIANTS_MATRIX_FULFILLED,
  payload: {
    data,
    sku,
  },
});

const fetchProductVariantsMatrixRejected = (
  sku: string,
  error: ErrorType,
): FetchProductVariantsMatrixRejectedAction => ({
  type: FETCH_VARIANTS_MATRIX_REJECTED,
  payload: {
    error,
    sku,
  },
});

export {
  fetchProductVariantsMatrix,
  fetchProductVariantsMatrixFulfilled,
  fetchProductVariantsMatrixRejected,
};
